import type { HelpMenuItem, HelpMenuKey } from '@klausapp/app-navigation/types'
import i18n from '@/i18n'
import analytics from '@/utils/analytics'
import useHelpMenu from '@/composables/useHelpMenu'
import { showPalette } from '@/modules/application/components/CommandPalette/utils/useCommandPalette'
import { session } from '@/composables/useSession'

export function useHelpMenuItems() {
  const { openShortcutsModal, openSupportChat } = useHelpMenu()

  const helpMenuItems: HelpMenuItem[] = [
    {
      label: i18n.t('modules.application.navbar.support_center'),
      href: i18n.t('support_links.zendesk_help'),
      key: 'knowledge',
    },
    {
      label: i18n.t('modules.application.navbar.chat'),
      key: 'chat',
    },
    {
      label: i18n.t('modules.application.navbar.community'),
      href: i18n.t('support_links.community'),
      key: 'community',
    },
    {
      label: i18n.t('modules.application.navbar.shortcuts'),
      key: 'shortcuts',
    },
    {
      label: i18n.t('modules.application.navbar.changelog'),
      href: i18n.t('support_links.whats_new_in_zendesk'),
      key: 'news',
    },
    ...(session.features.zendeskUiNavigation
      ? []
      : [
          {
            label: i18n.t('modules.application.navbar.command_palette'),
            key: 'jump',
          } as unknown as HelpMenuItem,
        ]),
  ]

  const onHelpMenuItemClick = (key: HelpMenuKey | 'help' | 'jump'): void => {
    switch (key) {
      case 'help':
        analytics.navbarEvent('Clicked navbar', 'Help menu')
        break
      case 'chat':
        openSupportChat()
        break
      case 'shortcuts':
        openShortcutsModal()
        break
      case 'jump':
        showPalette.value = !showPalette.value
        break
      default:
        return
    }
  }

  return {
    helpMenuItems,
    onHelpMenuItemClick,
  }
}
